// Groups account/session actions behind a small auth application boundary.
import type { AuthAccountPort } from '../core/types';

export function createAuthAccountService(port: AuthAccountPort) {
  return {
    signOut() {
      return port.signOut();
    },
    getCurrentUserId() {
      return port.getCurrentUserId();
    },
  };
}
